import React from "react";
// import { useDispatch } from "react-redux";
// import { useHistory } from "react-router-dom";

// import { ALERT } from "../constants/actionTypes";

// import { approvePayment } from "../utils/approvePayment";

// import { useFlutterwave, closePaymentModal } from "flutterwave-react-v3";

const Flutterwave = ({ id, email, price, projectName, urgent }) => {
  // const dispatch = useDispatch();
  // const history = useHistory();

  // const config = {
  //   public_key: process.env.REACT_APP_FLUTTERWAVE_KEY,
  //   tx_ref: Date.now(),
  //   amount: Math.ceil(price * 100) / 100,
  //   currency: "USD",
  //   payment_options: "card,mobilemoney,ussd",
  //   customer: {
  //     email,
  //   },
  //   customizations: {
  //     title: `Project ${projectName}`,
  //     description: "Payment for OneConverse translation service",
  //     logo: "https://festive-johnson-bacbb6.netlify.app/static/media/logo.1578144c.svg",
  //   },
  // };

  // const handleFlutterPayment = useFlutterwave(config);

  return (
    <button
      className="border-0 outline-0 p-10 mt-40 italics"
      onClick={() => {
        // handleFlutterPayment({
        //   callback: async (response) => {
        //     const payment = {
        //       reference: response.tx_ref,
        //       date: new Date(),
        //       gateway: "flutterwave",
        //       amount: Math.ceil(price * 100),
        //       email,
        //     };

        //     approvePayment(
        //       id,
        //       payment,
        //       dispatch,
        //       history,
        //       urgent,
        //       Math.ceil(price * 100)
        //     );

        //     closePaymentModal();
        //   },
        //   onClose: () => {
        //     dispatch({
        //       type: ALERT,
        //       payload: {
        //         severity: "warning",
        //         message: "Transaction cancelled",
        //         duration: 5000,
        //         display: true,
        //       },
        //     });
        //   },
        // });
      }}
    >
      FlutterWave
    </button>
  );
};

export default Flutterwave;
